import React, { useContext, useEffect, useRef, useState } from 'react'
import { ContextGloball } from '../Context/ContextGlobal'
import * as XLSX from 'xlsx';
import MsgUtils from '../Tools/MsgUtils';
import ItemSucAnaPro from './ItemSucAnaPro';
import DateConverter from '../Tools/DateConverter';
import { useDownloadExcel } from 'react-export-table-to-excel';
const server = process.env.REACT_APP_SERVER;

const productos = [{ 'ID': 1, 'PRODUCTO': 'POLLO' }, { 'ID': 2, 'PRODUCTO': 'PAPA' }, { 'ID': 3, 'PRODUCTO': 'PIPOCA' },
{ 'ID': 5, 'PRODUCTO': 'ARROZ' }, { 'ID': 6, 'PRODUCTO': 'ARROZ FRIJOL' }, { 'ID': 7, 'PRODUCTO': 'HELADOS' },
{ 'ID': 8, 'PRODUCTO': 'JUGO FRUTILLA' }, { 'ID': 9, 'PRODUCTO': 'JUGO MANGO' }, { 'ID': 10, 'PRODUCTO': 'JUGO MARACUYA' }] 

const tipo = [{ 'ID': 0, "TIPO": 'DIARIO' }, { 'ID': 1, "TIPO": 'MENSUAL' }, { 'ID': 2, "TIPO": 'ANUAL' }]
function AnalisisProyeccion() {
    const { setLoading } = useContext(ContextGloball)
    const [idProducto, setIdProducto] = useState(0);
    const [sucursales, setSucursales] = useState([]);
    const [idSucursal, setIdSucursal] = useState(0);
    const [actualizar, setActualizar] = useState(false);
    const [fechaFin, setFechaFin] = useState('');
    const [fechaIni, setFechaIni] = useState('');
    const [viewT, setViewT] = useState(0);
    const tableRef = useRef();
    function obtenerSucursales() {
        if (sucursales.length == 0) {
            setLoading(true);
            fetch(`${server}/sqlComun/getSucursales`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    'regional': JSON.parse(localStorage.getItem('__react_session__')).regional
                })
            })
                .then(res => res.json())
                .then(data => {
                    setLoading(false);
                    if (data.error) {
                        MsgUtils.msgError(data.error);
                    } else {
                        setSucursales(data.ok);
                        setViewT(1);
                    }
                })
                .catch(error => MsgUtils.msgError(error));
        }
    }
    function comprobarFiltro(producto) {
        if (idSucursal == 0) {
            return true
        } else {
            return idSucursal == producto.ID_SUCURSAL
        }
    }
    function sumarValores(columna) {
        var table = document.getElementById('infoTabla')
        var tr = table.getElementsByTagName("tr");
        var suma = 0
        var i;
        for (i = 0; i < tr.length; i++) {
            var td = tr[i].getElementsByTagName("td")[columna];
            if (td) {
                var txtValue = td.textContent || td.innerText;
                var valor = parseFloat(txtValue);
                if(!isNaN(valor)){
                    suma = suma + valor;
                }
            }
        }
        return suma
    }
    function refrescarTotales() {
        setViewT(curr => curr + 1);
    }
    function crearArchivo(datos){
        var producto = productos.filter(item=>item.ID==idProducto)
        var data = []
        for (var dato of datos){
            for (var info of dato.DATOS){
                if(idProducto==1){
                    data.push([DateConverter.formatoFechaNumeric(info.FECHA),dato.SUCURSAL,
                        info.CANT_VENTAS/100,info.CANT_REQ/100,(info.CANT_REQ-info.CANT_VENTAS)/100,info.TRASP_ENTRANTE/100,info.TRASP_SALIENTE/100,info.CANT_SOBRANTE/100,producto[0].PRODUCTO
                    ])
                }else{
                    data.push([DateConverter.formatoFechaNumeric(info.FECHA),dato.SUCURSAL,
                        info.CANT_VENTAS,info.CANT_REQ,(info.CANT_REQ-info.CANT_VENTAS),info.TRASP_ENTRANTE,info.TRASP_SALIENTE,info.CANT_SOBRANTE,producto[0].PRODUCTO
                    ])
                }
            }
        }
        const ws = XLSX.utils.aoa_to_sheet([['FECHA', 'SUCURSAL','VENDIDO','PROYECTADO','DIFERENCIA','TRASP. ENTRANTE','TRASP.SALIENTE','SOBRANTE','PRODUCTO']]);
        const startingRow = 2; 
        XLSX.utils.sheet_add_aoa(ws, data, { origin: startingRow });

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Analisis Proyección');

        XLSX.writeFile(wb, `AnalisisProyeccion${DateConverter.getFechFuturaFormatoDefault(true)}.xlsx`);
        setLoading(false);
    }
    function generarExcel() {
        if (fechaFin != '' && fechaIni != '' && idProducto != 0) {
            setLoading(true)
            fetch(`${server}/reporte/getAnalisisProyeccionDetallado`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    'regional': JSON.parse(localStorage.getItem('__react_session__')).regional,
                    fechaFin,fechaIni,idProducto,sucursales
                })
            })
                .then(res => res.json())
                .then(data => {
                    if (data.error) {
                        setLoading(false);
                        MsgUtils.msgError(data.error);
                    } else {
                        crearArchivo(data.ok)
                    }
                })
                .catch(error => MsgUtils.msgError(error));
        }
    }
    const { onDownload } = useDownloadExcel({
        currentTableRef: tableRef.current,
        filename: `AnalisisProyeccion${DateConverter.getFechFuturaFormatoDefault(true)}`,
        sheet: 'Analisis Proyeccion'
    })    
    useEffect(() => {
        obtenerSucursales()
    }, [])
    return (
        <>
            <div className='container-fluid bg-dark bg-gradient py-1'>
                <div className='row row-cols gx-1 g-1'>
                    <div className='col' style={{ minWidth: '165px', maxWidth: '165px' }}>
                        <div className="input-group input-group-sm">
                            <span className="input-group-text bg-transparent text-light" style={{ border: 'none' }}>Desde</span>
                            <input type="date" className="form-control" value={fechaIni} onChange={(e) => setFechaIni(e.target.value)} />
                        </div>
                    </div>
                    <div className='col' style={{ minWidth: '165px', maxWidth: '165px' }}>
                        <div className="input-group input-group-sm">
                            <span className="input-group-text bg-transparent text-light" style={{ border: 'none' }}>Hasta</span>
                            <input type="date" className="form-control" value={fechaFin} onChange={(e) => setFechaFin(e.target.value)} />
                        </div>
                    </div>
                    <div className='col-4' style={{ minWidth: '160px', maxWidth: '210px' }}>
                        <div className="input-group input-group-sm">
                            <span className="input-group-text bg-transparent text-light" style={{ border: 'none' }}>Pro.</span>
                            <select className="form-select" value={idProducto} onChange={(e) => setIdProducto(e.target.value)}>
                                <option value={0}>Ninguno</option>
                                {productos.map((item, index) => {
                                    return (
                                        <option value={item.ID} key={index}>{item.PRODUCTO}</option>
                                    )
                                })}
                            </select>
                        </div>
                    </div>
                    
                    <div className='col' style={{ minWidth: '160px', maxWidth: '160px' }}>
                        <div className="input-group input-group-sm">
                            <span className="input-group-text bg-transparent text-light" style={{ border: 'none' }}>Suc.</span>
                            <select className="form-select" value={idSucursal} onChange={(e) => setIdSucursal(e.target.value)}>
                                <option value={0}>TODOS</option>
                                {sucursales.map((item, index) => {
                                    return (
                                        <option value={item.ID_SUCURSAL} key={index}>{item.SUCURSAL}</option>
                                    )
                                })}
                            </select>
                        </div>
                    </div>
                    <div className='col' style={{ minWidth: '110px', maxWidth: '110px' }}>
                        <button className='btn btn-secondary w-100 btn-sm' onClick={() => {
                            if (idProducto != 0) {
                                setViewT(0);
                                setActualizar(!actualizar);
                            } else {
                                MsgUtils.msgError("Elija un producto para la busqueda, por favor ....")
                            }
                        }}>
                            <i className="fa-solid fa-rotate-right"></i> Cargar
                        </button>
                    </div>
                    <div className='col' style={{ minWidth: '110px', maxWidth: '110px' }}>
                        <button className='btn btn-success w-100 btn-sm' onClick={onDownload}>
                            <i className="fa-solid fa-file-excel"></i> Excel
                        </button>
                    </div>
                </div>
            </div>
            <div className='table-responsive'>
                <table className="table table-dark table-sm table-bordered border-secondary" id="infoTabla" ref={tableRef}>
                    <thead>
                        <tr className='text-center'>
                            <th scope="col"></th>
                            <th scope="col">VENDIDO</th>
                            <th scope="col">PROYECTADO</th>
                            <th scope="col">DIFERENCIA</th>
                            {false&&<th scope="col">TRASP. ENTRANTE</th>}
                            <th scope="col">TRASP. ENTRANTE AUT</th>
                            <th scope="col">TRASP. ENTRANTE MAN</th>
                            <th scope="col">TRAS. ENTRANTE SUC</th>
                            <th scope="col">TRASP. SALIENTE</th>
                            {false&&<th scope="col">TRAS. SALIENTE SUC</th>}
                            <th scope="col">SOBRANTE</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sucursales.map((item, index) => {
                            if (comprobarFiltro(item)) {
                                return (
                                    <ItemSucAnaPro suc={item} key={index} fechaIni={fechaIni} actualizar={actualizar}
                                                   idProducto={idProducto} fechaFin={fechaFin} callback={refrescarTotales} />
                                )
                            }
                        })}
                    </tbody>
                    {(viewT > 0) &&
                    <tfoot className='fondoMostasa text-center'>
                        <tr>
                            <th>TOTAL</th>
                            <th>{sumarValores(0).toFixed(2)}</th>
                            <th>{sumarValores(1).toFixed(2)}</th>
                            <th>{sumarValores(2).toFixed(2)}</th>
                            <th>{sumarValores(3).toFixed(2)}</th>
                            <th>{sumarValores(4).toFixed(2)}</th>
                            <th>{sumarValores(5).toFixed(2)}</th>
                            <th>{sumarValores(6).toFixed(2)}</th>
                            <th>{sumarValores(7).toFixed(2)}</th>
                            {false&&<th>{sumarValores(8).toFixed(2)}</th>}
                            {false&&<th>{sumarValores(9).toFixed(2)}</th>}
                        </tr>
                    </tfoot> }
                </table>
            </div>

        </>
    )
}

export default AnalisisProyeccion